export default class EventEmitter {
  static emit(name, detail = {}, $element = document) {
    const event = new CustomEvent(name, { detail });
    $element.dispatchEvent(event);
    return event;
  }

  static on(name, callback = () => {}, $element = document) {
    $element.addEventListener(name, e => callback(e));
  }
}
